module.exports = __webpack_public_path__ + "static/img/success-tick.e24f4389.png";